/* @flow */
import idx from 'idx';
import * as React from 'react';
import Text from 'components/Text';
import LTISetup from 'admin/components/LTISetup';

const b = str => <Text weight="semibold">{str}</Text>;

const stepsFn = lti => {
  const url = idx(lti, _ => _.config.configUrl) || '*generate credential to generate URL*';

  const steps = [
    <Text size="medium">Open Schoology in a new Browser Tab.</Text>,
    <Text size="medium">
      In Schoology, click {b`Tools`} and select {b`School Management`} from the dropdown.
    </Text>,
    <Text size="medium">Go to the {b`Integration`} Tab in the left navigation menu.</Text>,
    <Text size="medium">Select {b`External Tools`} tab at the top right of the page.</Text>,
    <Text size="medium">Click Add {b`External Tool Provider`}.</Text>,
    <Text size="medium">Enter ‘Remind’ in the {b`Tool Name`} field. </Text>,
    <Text size="medium">
      Click {b`Generate Credentials`} below to generate a {b`Consumer Key`} and a {b`Shared Secret`}
      . Then go to Schoology and enter them into their respective fields.
    </Text>,
    <Text size="medium">
      Set the {b`Privacy`} to {b`Send Name and Email/Username of user who launches the tool`}.
    </Text>,
    <Text size="medium">
      Set {b`Configuration Type`} to {b`Manual`}.
    </Text>,
    <Text size="medium">
      Set {b`Configuration Type`} to {b`Domain`}.
    </Text>,
    <Text size="medium">
      Enter the Config XML {url} into the {b`Domain / URL`} field.
    </Text>,
    <Text size="medium">Click {b`Submit`}.</Text>,
  ];

  return {
    steps,
    keyGeneratorStep: 7,
  };
};

class SchoologyLTI extends React.Component<*, *> {
  render() {
    return (
      <LTISetup
        {...this.props}
        name="Schoology"
        stepsFn={stepsFn}
        logo={require('assets/images/schoology.svg')}
        images={[require('assets/images/schoology_lti_install_1.png')]}
      />
    );
  }
}

export default SchoologyLTI;
